import React, { useEffect } from "react";
import {
  PageLoader,
  PaginationSimple,
  PriceConvertor,
  SearchInput,
} from "components";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { fundraiserActions } from "store";
import { NotYet } from "../../components/table/notYet";
import { JoinMovementCard } from "../home/fragments";
import { fundraiserStatuses } from "../fundraisers";
import { ACTION_TYPES } from "./fragments/constants";
import { FindLoad, limit } from "utils";
import { Images } from "assets";

export const FindEvent = () => {
  const { fundraisersSearching } = useSelector((state) => ({
    fundraisersSearching: state.fundraiser.fundraisersSearching,
  }));
  const dispatch = useDispatch();
  const loader = FindLoad(ACTION_TYPES);
  const location = useLocation();
  const info = location?.state;
  const navigate = useNavigate();

  useEffect(() => {
    const params = {
      limit,
    };

    if (info?.keyword) {
      params.keyword = info.keyword;
    }
    if (info?.skip) {
      params.skip = info.skip;
    }

    dispatch(fundraiserActions.getFundraisersSearching(params));
  }, [dispatch, info]);

  return (
    <div className="find-event-page">
      <div className="container">
        <div className="find-event-box">
          <div className="find-event-title_search">
            <h2 className="find-event-title">Find an Event</h2>

            <p className="find-event-desc">
              Search for an events with or event code here
            </p>

            <SearchInput
              placeholder={"Search..."}
              searchKey={"keyword"}
              className="find-event-search"
            />
          </div>

          <div className="find-event-cards">
            {loader ? (
              <div style={{ height: "100%", width: "100%" }}>
                <PageLoader height={"60vh"} />
              </div>
            ) : (
              <div>
                {fundraisersSearching?.fundraisers?.length ? (
                  <div>
                    <div className="find-event-cards-wrapper">
                      {fundraisersSearching?.fundraisers.map((item, index) => (
                        <JoinMovementCard
                          classNameWrapper="find-event-card"
                          onClick={() => navigate(`/event/${item?.id}`)}
                          stickerLive={
                            item?.status === fundraiserStatuses.LIVE
                              ? "Active"
                              : "Past"
                          }
                          key={index}
                          item={{
                            ...item,
                            images:
                              item?.images?.length > 0
                                ? item?.images
                                : [
                                    {
                                      url: Images.needCardFrameWhite,
                                    },
                                  ],
                            title: item?.name,
                            description: "",
                            price: PriceConvertor({ price: item?.balance }),
                            percentage: "42%",
                          }}
                          showFirstButton={
                            item?.status === fundraiserStatuses.LIVE
                          }
                        />
                      ))}
                    </div>

                    {fundraisersSearching?.count > 0 && (
                      <PaginationSimple
                        count={fundraisersSearching?.count}
                        limitCountNumber={10}
                      />
                    )}
                  </div>
                ) : (
                  <NotYet height={"60vh"} />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
